import { render, staticRenderFns } from "./SelectedFlightListItem.vue?vue&type=template&id=252b4724&scoped=true"
import script from "./SelectedFlightListItem.vue?vue&type=script&lang=js"
export * from "./SelectedFlightListItem.vue?vue&type=script&lang=js"
import style0 from "./SelectedFlightListItem.vue?vue&type=style&index=0&id=252b4724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b4724",
  null
  
)

export default component.exports